import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { IFeature } from "../interfaces/ifeature";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

/**
 * @WhatItDoes A service to retrieve all features available in the system
 *
 * @HowToUseIt Inject the service
 */
@Injectable()
export class FeatureService extends BaseService {

   /**
    * Constructor for service
    * @param http angular http module
    * @param toastr toastr manager
    * @param authService Authorization Service
    */
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    /**
     * Returns all features
     */
    getAll(): Observable<IFeature[]> {
        return super.get(`/api/feature`).pipe(map((res: any) => res as IFeature[]));
    }
}





